//This file creates a CONTEXT outside of my components from which they can draw certain bits of state
//Wrap AuthProvider from here around the App in index.js so everything in the App has access to the context outlined here (for logged in user etc)
import { createContext, useState } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [displayGuesses, setDisplayGuesses] = useState([]);

  return (
    <AuthContext.Provider value={{ displayGuesses, setDisplayGuesses }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
